export default __webpack_public_path__ + "static/media/total-expenses.afbca3a0.svg";